module.exports = __webpack_public_path__ + "media/newstyle/images/slider-arrow-right-grey-58fff0a2b771556da876dec462a9c537.svg";